const toPositiveInteger = (value) => {
  const parsed = parseInt(value, 10)

  return Number.isInteger(parsed) && parsed > 0 ? parsed : 0
}

export const calculateReportRepeatTotalPage = ({
  rowCount = 0,
  rowPerPage,
  pageBreakAfterRows,
  lastPageRowPerPage,
  rowsOnFirstPageOnly = false,
} = {}) => {
  const totalRows = Math.max(parseInt(rowCount, 10) || 0, 0)
  const normalCapacity = toPositiveInteger(rowPerPage)
  const breakThreshold = toPositiveInteger(pageBreakAfterRows)

  if (!normalCapacity) return 1

  if (!breakThreshold) {
    return Math.max(Math.ceil(totalRows / normalCapacity), 1)
  }

  if (totalRows <= breakThreshold) return 1
  if (rowsOnFirstPageOnly) return 2

  const lastPageCapacity =
    toPositiveInteger(lastPageRowPerPage) || normalCapacity
  const middleRows = Math.max(
    totalRows - normalCapacity - lastPageCapacity,
    0,
  )

  return 2 + Math.ceil(middleRows / normalCapacity)
}

export const getReportRepeatPageSlice = ({
  rowCount = 0,
  pageNo = 1,
  rowPerPage,
  pageBreakAfterRows,
  lastPageRowPerPage,
  rowsOnFirstPageOnly = false,
} = {}) => {
  const totalRows = Math.max(parseInt(rowCount, 10) || 0, 0)
  const currentPage = Math.max(parseInt(pageNo, 10) || 1, 1)
  const normalCapacity = toPositiveInteger(rowPerPage)
  const breakThreshold = toPositiveInteger(pageBreakAfterRows)

  if (!normalCapacity) {
    return { start: 0, end: totalRows, totalPage: 1 }
  }

  const totalPage = calculateReportRepeatTotalPage({
    rowCount: totalRows,
    rowPerPage: normalCapacity,
    pageBreakAfterRows: breakThreshold,
    lastPageRowPerPage,
    rowsOnFirstPageOnly,
  })

  if (breakThreshold && rowsOnFirstPageOnly) {
    return currentPage === 1
      ? { start: 0, end: totalRows, totalPage }
      : { start: totalRows, end: totalRows, totalPage }
  }

  if (!breakThreshold || totalPage === 1) {
    const start = normalCapacity * (currentPage - 1)

    return {
      start,
      end: Math.min(start + normalCapacity, totalRows),
      totalPage,
    }
  }

  if (currentPage === 1) {
    return {
      start: 0,
      end: Math.min(normalCapacity, totalRows),
      totalPage,
    }
  }

  if (currentPage >= totalPage) {
    const lastPageCapacity =
      toPositiveInteger(lastPageRowPerPage) || normalCapacity
    const start =
      totalRows <= normalCapacity
        ? totalRows
        : Math.max(normalCapacity, totalRows - lastPageCapacity)

    return { start, end: totalRows, totalPage }
  }

  const finalPageStart = Math.max(
    normalCapacity,
    totalRows -
      (toPositiveInteger(lastPageRowPerPage) || normalCapacity),
  )
  const start = normalCapacity * (currentPage - 1)

  return {
    start,
    end: Math.min(start + normalCapacity, finalPageStart),
    totalPage,
  }
}
